/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Basic
 *
 * 1 = AveragePay
 */
export enum HolidayCalculationEnum {
  Basic = 0,
  AveragePay = 1,
}
